import { ChevronLeft } from 'lucide-react';

const Header = ({ heading, subHeading, navigate, actionButton, tabSelector }) => {
  return (
    <div className="bg-white p-4 sm:p-6 rounded-xl shadow-md mb-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
        <div className="text-left min-w-0">
          {/* <h1 className="text-3xl font-medium text-primary mb-1">{heading}</h1> */}
          <p className="text-gray-600 text-sm break-words">{subHeading}</p>
        </div>
        {actionButton && (
          <div className="w-full sm:w-auto">
            {actionButton}
          </div>
        )}
      </div>

      {/* Tab Selector */}
      {tabSelector && (
        <div className="mt-2 min-w-0">
          {tabSelector}
        </div>
      )}
    </div>
  );
};

export default Header;